import { tabs } from "../data";
import Tab from "./Tab";
import profilePic from "../assets/seenthia.jpeg"

function Tabs(props: any) {
    const { activeTab, parentOnClick } = props;
    const altText = "Cynthia in some setting.";
    const hoverText = "Say cheese!";
    return (
        <div className="nav-bar">
            <img src={profilePic} alt={altText} title={hoverText}></img>
            <ul>
                <li>c y n t h i a</li>    
                {tabs.map( function(tab: string, index: number) {
                    var isActive = index === activeTab;
                    return (
                        <li key={tab}>
                            <Tab 
                                key={tab}
                                index={index}
                                isActive={isActive}
                                text={tab}
                                parentOnClick={parentOnClick}
                            />
                        </li>
                    )
                })}
                <li className="email">email: cyndo(at)cs(dot)washington(dot)edu</li>
                <a href="https://scholar.google.com/citations?user=NSGz35YAAAAJ&hl=en" className="email">google scholar</a>
            </ul>
        </div>
    )
}

export default Tabs